// function common header crm links
// Helper function to check user permissions
const hasPermission = (currentUserRole, moduleaccess, moduleName) => {
  return (
    currentUserRole === "ADMIN" ||
    currentUserRole === "SUPER_ADMIN" ||
    moduleaccess.includes(moduleName)
  );
};

const commonHeaderLinkLists = (t) => {
  // loggedin user details to get the role
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // get the role and allow for admin or superadmin
  const currentUserRole = userInfo.role ? userInfo.role.slug : "USER";

  // get module access for roles other than admin and superadmin
  const moduleaccess = localStorage.getItem("moduleaccess");

  //console.log("currentUserRole", currentUserRole);

  // console.log("moduleaccess", moduleaccess);

  const headerTabs = [];

  const tabsConfig = [
    {
      module: "MOD_PATIENT_PRESCRIPTION_MANAGEMENT",
      title: t("Prescriptions"),
      link: "/admin/patientmanagement/prescriptions",
    },
    {
      module: "MOD_CONDITION_MANAGEMENT",
      title: t("Conditions"),
      link: "/admin/patientmanagement/conditions",
    },
    {
      module: "MOD_MEDICATION_MANAGEMENT",
      title: t("Medications"),
      link: "/admin/patientmanagement/medications",
    },
    {
      module: "MOD_ALLERGY_MANAGEMENT",
      title: t("Allergies"),
      link: "/admin/patientmanagement/allergies",
    },
    {
      module: "MOD_IMMUNIZATION_MANAGEMENT",
      title: t("Immunizations"),
      link: "/admin/patientmanagement/immunizations",
    },
    {
      module: "MOD_RESULT_MANAGEMENT",
      title: t("Results"),
      link: "/admin/patientmanagement/results",
    },
    {
      module: "MOD_APPOINTMENT_MANAGEMENT",
      title: t("Appointments"),
      link: "/admin/patientmanagement/appointments",
    },
    {
      module: "MOD_ELECTRONIC_PRESCRIPTION_MANAGEMENT",
      title: t("Electronic Prescriptions"),
      link: "/admin/patientmanagement/electronicprescriptions",
    },
    {
      module: "MOD_ORDER_MANAGEMENT",
      title: t("Orders"),
      link: "/admin/patientmanagement/orders",
    },
    {
      module: "MOD_CONSENT_MANAGEMENT",
      title: t("Consent"),
      link: "/admin/patientmanagement/consent",
    },
    {
      module: "MOD_PATIENT_SETTINGS_MANAGEMENT",
      title: t("Settings"),
      link: "/admin/patientmanagement/settings",
    },
    {
      module: "MOD_VITAL_MANAGEMENT",
      title: t("Vitals"),
      link: "/admin/patientmanagement/vitals/bloodpressure",
    },
  ];

  tabsConfig.forEach((tabConfig) => {
    if (hasPermission(currentUserRole, moduleaccess, tabConfig.module)) {
      headerTabs.push({ title: tabConfig.title, link: tabConfig.link });
    }
  });

  return headerTabs;
};

export { commonHeaderLinkLists };
